import { render, staticRenderFns } from "./CuponCard.vue?vue&type=template&id=fee56530&scoped=true&"
import script from "./CuponCard.vue?vue&type=script&lang=js&"
export * from "./CuponCard.vue?vue&type=script&lang=js&"
import style0 from "./CuponCard.vue?vue&type=style&index=0&id=fee56530&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee56530",
  null
  
)

export default component.exports